/* @flow */
import * as React from 'react';
import DeviceActions from 'actions/DeviceActions';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Input from 'components/Input.jsx';
import ToastActions from 'actions/ToastActions';
import EventTracking from 'lib/EventTracking';

type Props = {
  onDone: Function,
  onRequestHide: Function,
  oldUserEmail: string,
  eventScreenName: string,
};

type State = {
  code: string,
};

const CODE_LENGTH = 4;
class EmailMergeConfirmationCode extends React.Component<Props, State> {
  state: State = {
    code: '',
  };
  onCodeChange = (event: SyntheticEvent<>) => {
    // $FlowFixMe
    if (event.currentTarget.value.length === CODE_LENGTH) {
      this.setState({ code: event.currentTarget.value });
    }
  };

  confirm = () => {
    const onFailure = error => {
      ToastActions.showAPIError(error);
      this.props.onRequestHide();
    };

    EventTracking.tap(this.props.eventScreenName, 'EmailMergeConfirmationCodeSubmit');
    DeviceActions.emailMergeRequest(this.state.code, this.props.oldUserEmail).then(
      this.props.onDone,
      onFailure
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="EmailMergeConfirmationCode"
        onConfirm={this.confirm}
        staticModal={false}
        onRequestHide={this.props.onRequestHide}
        size="medium"
        actionButtonText="Submit"
        cancelButtonText="Cancel"
        title={`Enter your ${CODE_LENGTH}-digit confirmation code`}
        subtext={`Check your email for the code — it was sent to ${this.props.oldUserEmail}`}>
        <Input
          red="code"
          autofocus
          placeholder="0000"
          maxLength={CODE_LENGTH}
          // XXX this size is ignored by Input
          // size="small"
          onChange={this.onCodeChange}
        />
      </ConfirmDialog>
    );
  }
}
export default EmailMergeConfirmationCode;
